import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { NavService } from 'src/app/services/nav.service';
const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
})
export class FullComponent implements OnInit, OnDestroy,AfterViewInit {
  @ViewChild('leftsidenav') public sidenav: MatSidenav;
ngAfterViewInit(): void {
  this.navService.setSidenav(this.sidenav);
  this.cdr.detectChanges();
}

  private layoutChangesSubscription = Subscription.EMPTY;
  public isOver: boolean = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  
 isCollapsed = false;
  toggleCollapseds(): void {
    this.isCollapsed = !this.isCollapsed;
  }
  public sidenavOpened = true;
  constructor(private breakpointObserver: BreakpointObserver,private navService: NavService,  private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
  this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        this.isOver = state.breakpoints[MOBILE_VIEW];
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.sidenavOpened = !this.isOver;
        if (this.isOver) {
          this.isCollapsed = false;
        }
      });
  }
onBackdropClick(): void {
  this.sidenavOpened = false;
}
  ngOnDestroy(): void {
    this.layoutChangesSubscription.unsubscribe();
  }
  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }

  toggleCollapsed(): void {
    this.isContentWidthFixed = false;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape' && this.sidenav && this.sidenav.opened) {
      event.preventDefault();
      console.log('Esc key pressed, but sidenav will not close.');
    }
  }
}
